const translations = {
    INFOBOX_PASSES_AVAILABLE: {
        description: 'Passes Available',
        primaryValue: 'Passes Available',
        stringKey: 'INFOBOX_PASSES_AVAILABLE',
    },
    INFOBOX_PASS_AVAILABLE: {
        description: 'Pass Available',
        primaryValue: 'Pass Available',
        stringKey: 'INFOBOX_PASS_AVAILABLE',
    },
    REQUEST_PASS: {
        description: 'Request A Pass',
        primaryValue: 'Request A Pass',
        stringKey: 'INFOBOX_REQUEST_PASS_BTN',
    },
    INFOBOX_PASS: {
        description: 'Pass',
        primaryValue: 'Pass',
        stringKey: 'INFOBOX_PASS',
    },
    INFOBOX_PASSES: {
        description: 'Passes',
        primaryValue: 'Passes',
        stringKey: 'INFOBOX_PASSES',
    },
    INFOBOX_UNLIMITED: {
        description: 'Unlimited',
        primaryValue: 'Unlimited',
        stringKey: 'INFOBOX_UNLIMITED',
    }
}

export default translations;